import { SearchErrorsEnum } from '../enums/search-errors.enum';

export class SearchError extends Error {
    constructor(m: string, public type: SearchErrorsEnum) {
        super(m);
        // HACK: deals with Error resetting the prototype which makes the type incorrect
        Object.setPrototypeOf(this, SearchError.prototype);
    }
}
